import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { LockerNumberService } from '../../core/services/locker-number.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-studio-locker',
    imports: [RouterLink, FormsModule, PagerComponent, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;編集</span>
        </div>
        <div class="card-body">
          <div class="col-md-12"><app-flash-message></app-flash-message></div>
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <table class="table-bordered table-sm">
                  <thead>
                    <tr><th width="50%">表示ID</th><th width="50%">店舗名</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>{{studio.sortBy}}</td><td>{{studio.name}}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br /><br />
            <strong>ロッカー番号の登録</strong>
            <hr />
            <form novalidate name="lockerEditForm" #lockerEditForm="ngForm">
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">ロッカー月額タイプ</label>
                  <select class="form-control" [(ngModel)]="lockerNumberPlan" name="lockerNumberPlan" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (p of products3; track p.id) {
                      <option [ngValue]="p">{{productLabel(p)}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="row" style="align-items: flex-end;">
                <div class="form-group col-md-6">
                  <label class="col-form-label">ロッカー番号</label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <input type="number" class="form-control" min="1" [(ngModel)]="lockerNumberStart" name="lockerNumberStart" required>
                    </div>
                    <span>&nbsp;~&nbsp;</span>
                    <div class="bisected-input">
                      <input type="number" class="form-control" min="1" [(ngModel)]="lockerNumberEnd" name="lockerNumberEnd" required>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <button type="button" class="btn btn-success" (click)="saveLockerNumber()"
                    [disabled]="lockerEditForm.invalid || registerRangeInvalid || registerDisabled">
                    <i class="fa s-icon-plus"></i>&nbsp;登録
                  </button>
                </div>
              </div>
            </form>
            <br /><br />
            <strong>ロッカー番号の削除</strong>
            <hr />
            <form novalidate name="lockerRemoveForm" #lockerRemoveForm="ngForm">
              <div class="row" style="align-items: flex-end;">
                <div class="form-group col-md-6">
                  <label class="col-form-label">ロッカー番号</label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <input type="number" class="form-control" min="1" [(ngModel)]="removeLockerNumberStart" name="removeLockerNumberStart" required>
                    </div>
                    <span>&nbsp;~&nbsp;</span>
                    <div class="bisected-input">
                      <input type="number" class="form-control" min="1" [(ngModel)]="removeLockerNumberEnd" name="removeLockerNumberEnd" required>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <button type="button" class="btn btn-danger" (click)="removeLockerNumber()"
                    [disabled]="lockerRemoveForm.invalid || removeRangeInvalid || removeDisabled">
                    <i class="fa s-icon-delete"></i>&nbsp;削除
                  </button>
                </div>
              </div>
            </form>
            <br /><br />
            <strong>ロッカー番号一覧</strong>
            <hr />
            <div class="row">
              <div class="form-group col-md-6">
                <div class="form-group">
                  <label class="col-form-label" for="keyword">キーワード検索</label>
                  <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword" (ngModelChange)="keywordChanged()" class="form-control" placeholder="店舗名など">
                </div>
              </div>
              <div class="form-group col-md-4 d-flex align-items-end">
                <div class="form-group row">
                  <div class="col-md-12">
                    <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                      <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            @if (loading) {
              <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
            }
            @if (!loading && filteredLockers.length === 0) {
              <span>該当するデータはありません</span>
            }
            @if (filteredLockers.length > 0) {
              <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
              <table class="table table-bordered table-sm table-hover table-ptb-0">
                <thead>
                  <tr>
                    <th width="15%">ロッカー番号</th>
                    <th width="15%">会員ID</th>
                    <th width="25%">会員氏名(かな)</th>
                    <th width="30%">ロッカー月額タイプ</th>
                    <th width="15%">状態</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of pagedLockers; track item.id) {
                    <tr>
                      <td>{{item.lockerNumber}}</td>
                      <td>{{item.member?.memberCode}}</td>
                      <td>
                        @if (item.member?.lastName != null) {
                          {{item.member.lastName}}&nbsp;{{item.member.firstName}}&#040;{{item.member.lastNameKana}}&nbsp;{{item.member.firstNameKana}}&#041;
                        }
                      </td>
                      <td>{{item.product?.name}}</td>
                      <td>
                        @if (item.member?.status == null) { <span></span> }
                        @if (item.member?.status == 0) { <span>在籍中</span> }
                        @if (item.member?.status == 1) { <span>停止</span> }
                        @if (item.member?.status == 2) { <span>停止(除名)</span> }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
            }
          </div>
        </div>
      </div>
</div>
  `
})
export class StudioLockerComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private lockerNumberService = inject(LockerNumberService);
  private route = inject(ActivatedRoute);
  private flash = inject(FlashService);

  studioId!: number;
  studio: any = {};
  lockers: any[] = [];
  products: any[] = [];
  lockerNumberPlan: any = null;
  lockerNumberStart: number | null = null;
  lockerNumberEnd: number | null = null;
  removeLockerNumberStart: number | null = null;
  removeLockerNumberEnd: number | null = null;
  keyword = '';
  loading = true;
  registerDisabled = false;
  removeDisabled = false;
  readonly pageLimit = 300;
  pageIndex = 0;

  get products3() { return this.products.filter(p => Number(p.productType) === 3); }

  get registerRangeInvalid(): boolean {
    return this.rangeInvalid(this.lockerNumberStart, this.lockerNumberEnd);
  }

  get removeRangeInvalid(): boolean {
    return this.rangeInvalid(this.removeLockerNumberStart, this.removeLockerNumberEnd);
  }

  get filteredLockers(): any[] {
    return this.lockers.filter(item => matchesNestedKeyword(item, this.keyword));
  }

  get pagedLockers(): any[] {
    const begin = this.pageIndex * this.pageLimit;
    return this.filteredLockers.slice(begin, begin + this.pageLimit);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredLockers.length / this.pageLimit);
  }

  goToPage(page: number): void {
    this.pageIndex = Math.max(0, Math.min(page, this.totalPages - 1));
  }

  keywordChanged(): void {
    this.pageIndex = 0;
  }

  clearFilter(): void {
    this.keyword = '';
    this.pageIndex = 0;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    this.studioId = +this.route.snapshot.params['studioId'];
    await this.loadData();
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    try {
      const [studioData, lockers, productData]: any[] = await Promise.all([
        this.studioService.list(this.studioId),
        this.studioService.getLockerNumber(this.studioId),
        this.studioService.getProduct(this.studioId),
      ]);
      this.studio = Array.isArray(studioData) ? (studioData[0] ?? {}) : (studioData ?? {});
      this.lockers = Array.isArray(lockers) ? lockers : [];
      this.products = (Array.isArray(productData) ? productData : []).filter((p: any) => p.status === 0);
    } finally {
      this.loading = false;
    }
  }

  productLabel(p: any): string {
    const price = Math.floor(p.amount * (1 + Number(p.taxRate?.rate ?? 0)));
    return `(¥${price.toLocaleString()}) ${p.name}`;
  }

  async saveLockerNumber(): Promise<void> {
    if (!this.lockerNumberPlan || this.registerRangeInvalid) return;
    this.registerDisabled = true;
    try {
      const start = this.lockerNumberStart!;
      const end = this.lockerNumberEnd!;
      const json = [];
      const lockerNumbers = [];
      for (let i = start; i <= end; i++) {
        lockerNumbers.push(i);
        json.push({ studioId: this.studioId, lockerNumber: i, productId: this.lockerNumberPlan.id });
      }
      const exists = await this.lockerNumberService.exists(this.studioId, lockerNumbers.join(','));
      // 旧版 studio.js:532-542: 登録済みを含むとdanger、成功はsuccess。いずれも先頭へscroll後に再取得
      if (exists) {
        this.flash.create('danger', '登録されていないロッカー番号を指定してください');
        window.scrollTo(0, 0);
        await this.loadData();
        return;
      }
      await this.lockerNumberService.create(json);
      this.flash.create('success', 'ロッカー番号を新規作成しました');
      window.scrollTo(0, 0);
      await this.loadData();
    } finally {
      this.registerDisabled = false;
    }
  }

  async removeLockerNumber(): Promise<void> {
    if (this.removeRangeInvalid) return;
    this.removeDisabled = true;
    try {
      const inUse = await this.lockerNumberService.inUse(
        this.studioId,
        this.removeLockerNumberStart!,
        this.removeLockerNumberEnd!,
      );
      // 旧版 studio.js:552-566: 使用中を含むとdanger、成功はsuccess。いずれも先頭へscroll後に再取得
      if (inUse) {
        this.flash.create('danger', '使用されていないロッカー番号を指定してください');
        window.scrollTo(0, 0);
        await this.loadData();
        return;
      }
      await this.lockerNumberService.remove({
        studioId: this.studioId,
        start: this.removeLockerNumberStart,
        end: this.removeLockerNumberEnd,
      });
      this.flash.create('success', 'ロッカー番号を削除しました');
      window.scrollTo(0, 0);
      await this.loadData();
    } finally {
      this.removeDisabled = false;
    }
  }

  private rangeInvalid(start: number | null, end: number | null): boolean {
    if (start == null || end == null || start < 1 || end < 1) return true;
    const difference = end - start;
    return difference < 0 || difference > 1000;
  }
}
